module.exports = __webpack_public_path__ + "larger-sepia.png?e8ed2ab660e2e0a17eb8c7806fcdd97e";